import { Checkbox, FormControlLabel } from "@mui/material";
import { useState } from "react";
import Pencil from "../../../../../Assets/Icons/Admin panel/Pencil.svg";
import Delete from "../../../../../Assets/Icons/Admin panel/Delete.svg";
import Chat from "../../../../../Assets/Icons/Admin panel/Chat.svg";
import ImagePreloader from "./ImagePreloader";
import FailModal from "../../../../../Components/FailModal";

const CategoriesTableRow = (props) => {
  const [ContextMenuIsOpen, setContextMenuIsOpen] = useState(false);
  const [DeleteIsOpen, setDeleteIsOpen] = useState(false);

  const toggleDelete = () => {
    setContextMenuIsOpen(false);
    setDeleteIsOpen(true);
  };

  const requestDeleteUser = () => {
    setDeleteIsOpen(false);
    props.ToggleDeleteUser(props.Item.id);
  };

  const swapType = (Profile) => {
    if (Profile === "ROLE_ADMIN") {
      return "Admin";
    } else {
      return "User";
    }
  };

  const displayName = () => {
    let Name = props.Item.name;
    if (Name) {
      if (Name.length <= 20) {
        return Name;
      } else {
        return Name.slice(0, 16) + "...";
      }
    } else {
      return "N/A";
    }
  };

  return (
    <div className="table-row">
      <ImagePreloader Images={[Pencil, Delete, Chat]} />
      <FailModal
        reverse
        show={DeleteIsOpen}
        title="Delete category?"
        description="Are you sure you want to delete this category?"
        onCancel={() => setDeleteIsOpen(false)}
        onRetry={requestDeleteUser}
        retryText="Delete"
      />
      {ContextMenuIsOpen ? (
        <div
          className="outline"
          onClick={() => setContextMenuIsOpen(false)}
        ></div>
      ) : null}
      <div className="large">{displayName()}</div>
      <div className="medium status">
        <div
          className={props.Item.enabled ? "circle" : "circle circle-inactive"}
        ></div>
        <p>{props.Item.enabled ? "Active" : "Inactive"}</p>
      </div>
      <div
        className="context-menu-trigger"
        onClick={() => setContextMenuIsOpen(true)}
      ></div>
      {ContextMenuIsOpen ? (
        <section className="context-menu">
          <div
            className="context-menu-row"
            onClick={() => props.EditCategory()}
          >
            <img src={Pencil} />
            <section className="menu-row-text">
              <p className="row-name">Edit</p>
              <p className="row-info">Edit category</p>
            </section>
          </div>
          <div className="context-menu-row" onClick={() => toggleDelete()}>
            <img src={Delete} />
            <section className="menu-row-text">
              <p className="row-name">Delete</p>
              <p className="row-info">Delete category permenantly</p>
            </section>
          </div>
        </section>
      ) : null}
      {/* {props.ErrorRowIndex === props.Index ? (
        <span class="error-text">
          {
            "The category cannot be deleted as it has already been assigned to a product (image)."
          }
        </span>
      ) : null} */}
    </div>
  );
};

export default CategoriesTableRow;
